<template>

	<div class="cart-table--wrapper">
		<button class="btn trigger--cart-mobile d-md-none" v-if="products.length > 0 && !nocollapse" @click="toggleMobileCart" :class="{ 'is-open': mobileopen }">
			<span>{{ $__('cart.table.summary') }} <strong>{{ `(${formatPrice(totals.total)})` }}</strong></span>
			<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-chevron-down"></use></svg>
		</button>
		<div class="cart-table--wrapper-inner" :class="{ 'd-block py-2': nocollapse}">
			<h4 class="d-none d-md-block cart-content-title" v-text="$__('cart.table.summary')"></h4>
			<table class="vld-parent table cart-table" ref="cartTable">
				<tbody>
				<tr
					v-for="(item, index) in products"
					:key="item.id"
				>
					<td class="cart-table--picture">
						<img loading="lazy" :src="item.picture" class="img-fluid" :alt="item.title">
					</td>
					<td class="cart-table--title">
						<div class="row">
							<div class="col-9 title">
								<h6 v-text="item.title"></h6>
								<span class="price-per-item">{{ $__('cart.table.price_per_unit') }}: <span v-html="formatPrice(item.price)"></span>
								</span>
								<span class="category" v-text="item.category"></span>
							</div>
							<div class="col-auto ml-auto prices">
								<span v-html="formatPrice(item.subtotal)" class="price-sum"></span>
							</div>
							<div class="col-auto ml-auto prices">
								<span v-if="item.is_free_shipping">{{ $__('cart.table.free_shipping') }}</span>
							</div>
						</div>
						<div class="row actions">
							<div v-if="item.fixed_price === null" class="col-auto amount">
								<span v-text="$__('cart.quantity')"></span>
								<vue-numeric-input
									:value="item.amount"
									:min="1"
									:max="99"
									:step="1"
									size="120px"
									align="center"
									@input="updateCart($event, item.id)"
								></vue-numeric-input>
								<input type="hidden" v-model="qty[item.id]" :data-qty="item.amount">
							</div>
							<div class="col-auto ml-auto remove">
								<button @click.prevent="removeFromCart(item.id, item.title, item.subtotal, item.amount, item, index)" type="button" class="btn btn-plain cart-remove-button ml-auto"><svg-use icon="x-circle" /></button>
							</div>
						</div>
					</td>
				</tr>
				</tbody>
				<tfoot v-if="showTotals">
				<tr v-if="extras.coupon">
					<td colspan="2">
						<div class="totals--payment">
							<span>{{ $__('cart.table.coupon.title') }} ({{ extras.coupon.code }})</span>
							<span>-{{ parseInt(extras.coupon.value) }}{{ extras.coupon.pt ? `%` : `` }}<button @click.prevent="removeCoupon" type="button" class="btn btn-plain cart-remove-coupon ml-auto"><svg-use icon="x-circle" /></button></span>
						</div>
					</td>
				</tr>
				<tr class="totals--payment-wrapper" v-if="extras.payment && extras.payment.price > 0">
					<td colspan="2">
						<div class="totals--payment">
							<span v-text="extras.payment.title"></span>
							<span v-html="formatPrice(extras.payment.price)"></span>
						</div>
					</td>
				</tr>
				<tr class="totals--shipping-wrapper" v-if="extras.shipping && extras.shipping.title != '' && !isNaN(extras.shipping.price)">
					<td colspan="2">
						<div v-if="extras.shipping.price !== extras.shipping.price_full" class="totals--shipping-full-price">
							<span v-text="$__('cart.table.shipping.full_price')"></span>
							<span v-html="formatPrice(extras.shipping.price_full)"></span>
						</div>
						<div v-if="extras.shipping.price !== extras.shipping.price_full" class="totals--shipping-discount">
							<span v-text="$__('cart.table.shipping.discount')"></span>
							<span v-html="formatPrice(extras.shipping.price - extras.shipping.price_full)"></span>
						</div>
						<div class="totals--shipping">
							<span v-text="extras.shipping.title"></span>
							<span v-html="formatPrice(extras.shipping.price)"></span>
						</div>
					</td>
				</tr>
<!--				<tr class="totals&#45;&#45;subtotal-wrapper">-->
<!--					<td colspan="2">-->
<!--						<div class="totals&#45;&#45;subtotal">-->
<!--							<span v-text="$__('cart.table.sums.wo_vat')"></span>-->
<!--							<span v-html="formatPrice(totals.subtotal)"></span>-->
<!--						</div>-->
<!--					</td>-->
<!--				</tr>-->
				<tr class="totals--total-wrapper">
					<td colspan="2">
						<div class="totals--total">
							<span v-text="$__('cart.table.sums.wvat')"></span>
							<span v-html="formatPrice(totals.total)"></span>
						</div>
					</td>
				</tr>
				</tfoot>
			</table>

			<div class="coupon-area">
				<p v-if="! couponopen && !extras.coupon">{{ $__('cart.table.coupon.lead') }} <button class="btn btn-link btn-sm" @click="couponopen = ! couponopen" v-text="$__('cart.table.coupon.button')"></button> <span>&nbsp;&nbsp;<sup>*</sup><small style="font-weight: bold;">{{ $__('cart.table.coupon.warning') }}</small></span></p>
				<div class="input-group" v-if="couponopen && !extras.coupon">
					<input type="text" v-model="coupon" class="form-control" :placeholder="$__('cart.table.coupon.placeholder')" :aria-label="$__('cart.table.coupon.placeholder')" aria-describedby="button-coupon">
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" id="button-coupon" @click="submitCoupon" v-text="$__('cart.table.coupon.add')"></button>
					</div>
				</div>
				<div v-if="couponstate" class="coupon-area--message" :class="{ '--error': couponstate.error == 1 }">{{ couponstate.description }}</div>
			</div>

		</div>
	</div>

</template>

<script>

	import { mapGetters, mapState } from 'vuex'
	import VueNumericInput from 'vue-numeric-input';

	export default {
		name: 'CartTable',
		components: {
			VueNumericInput,
		},
		data () {
			return {
				mobileopen: true,
				coupon: null,
				couponopen: false,
				couponstate: null,
				qty: []
			}
		},
		props: {
			full: {
				type: Boolean,
				default: true
			},
			showTotals: {
				type: Boolean,
				default: true
			},
			nocollapse: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapGetters('cart', {
				products: 'cartProducts',
				extras: 'cartExtras',
				totals: 'cartTotals',
			})
		},
		watch: {
			products(oldVal, newVal) {
				this.products.forEach(obj => {
					this.qty.push({
						id: obj.id,
						amount: obj.amount
					})
				})
			}
		},
		methods: {
			updateCart: _.debounce(function (amount, item_id) {
				try {
					// EEC change amount
					const oldQty = this.qty.find(obj => obj.id === item_id)
					const product = this.products.find(obj => obj.id === item_id)
					const eventName = oldQty.amount > amount ? 'EEC_remove_from_cart' : 'EEC_add_to_cart';
					const category = product.eec_parent_category ? product.eec_parent_category : product.category
					const subcategory = !product.eec_parent_category ? '' : product.category

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'event_params': null, 'ecommerce': null});
					window.dataLayer.push({
						'event': 'RO_event_EEC',
						'event_params': {
							'gtm_name': eventName,
						},
						'ecommerce': {
							'currency': global.current_currency,
							'items': [{
								'item_id': product.product_id,
								'item_name': product.title,
								'item_variant': undefined,
								'item_brand': 'Lupit Pole',
								'item_category': category ? category : undefined,
								'item_category2': subcategory ? subcategory : undefined,
								'price': product.eec_price,
								'discount': product.eec_discount,
								'affiliation': product.eec_affiliate ? product.eec_affiliate : undefined,
								'quantity': Math.abs(oldQty.amount - amount)
							}]
						}
					})
				} catch(e) {}

				let loader = this.$loading.show({
					container: this.$refs.cartcontainer,
				});
				this.$store.dispatch('cart/updateCart', {
					item: item_id,
					amount: amount
				}).then(response => {
					loader.hide()
					this.$root.$emit('recalculate-shipping')

					this.qty = []
					this.products.forEach(obj => {
						this.qty.push({
							id: obj.id,
							amount: obj.amount
						})
					})
				});
			}, 300),
			removeFromCart (item_id, item_title, item_subtotal, item_amount, item) {
				let loader = this.$loading.show({
					container: this.$refs.cartcontainer,
				});
				this.$store.dispatch('cart/removeFromCart', item_id).then(response => {
					loader.hide()
					this.$nextTick(() => { this.$root.$emit('recalculate-shipping'); });
				});
				try {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
					window.dataLayer.push({
						'event': 'removeFromCart',
						'ecommerce': {
							'remove': {
								'products': [{
									'name': item_title,
									'id': item_id,
									'price': item_subtotal.toString(),
									'quantity': item_amount
								}]
							}
						}
					});

					const category = item.eec_parent_category ? item.eec_parent_category : item.category
					const subcategory = !item.eec_parent_category ? '' : item.category

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'event_params': null, 'ecommerce': null});
					window.dataLayer.push({
						'event': 'RO_event_EEC',
						'event_params': {
							'gtm_name': 'EEC_remove_from_cart',
						},
						'ecommerce': {
							'currency': global.current_currency,
							'items': [{
								'item_id': item_id,
								'item_name': item_title,
								'item_variant': undefined,
								'item_brand': 'Lupit Pole',
								'item_category': category ? category : undefined,
								'item_category2': subcategory ? subcategory : undefined,
								'price': item.eec_price,
								'discount': item.eec_discount,
								'affiliation': item.eec_affiliate ? item.eec_affiliate : undefined,
								'quantity': item_amount,
							}]
						}
					});
				} catch (e) {}
			},
			formatPrice (price) {
				return numbro(parseFloat(price)).formatCurrency();
			},
			toggleMobileCart () {
				this.mobileopen = !this.mobileopen;
			},
			submitCoupon () {
				this.$store.dispatch('cart/setCoupon', {
					coupon: this.coupon,
				}).then((response) => {
					this.couponstate = response;
					this.$root.$emit('recalculate-shipping');
					this.$root.$emit('reset-spinwin-checked-state');
				});
			},
			removeCoupon () {
				this.$store.dispatch('cart/setCoupon', {
					coupon: null,
				}).then((response) => {
					this.couponstate = null;
					this.couponopen = false;
					this.$root.$emit('recalculate-shipping');
					this.$root.$emit('reset-spinwin-checked-state');
				});
			},

		},
		mounted() {

		}
	}

</script>
